import { render } from "./AprovarComplementacao.vue?vue&type=template&id=771d78ce&scoped=true"
import script from "./AprovarComplementacao.vue?vue&type=script&lang=js"
export * from "./AprovarComplementacao.vue?vue&type=script&lang=js"

import "./AprovarComplementacao.vue?vue&type=style&index=0&id=771d78ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771d78ce"]])

export default __exports__